import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";

import Fiocco from "../../../assets/images/premi-fiocco.svg";
import Persona from "../../../assets/images/premi-persona.svg";

const AWARDS = [
  { t: "Great Place to Work 2025" },
  {
    t: "Intranet Italia Champion",
    d: "primo premio nella categoria “Contenuti e iniziative”, progetto Ai Care, Reale Mutua",
  },
  {
    t: "Health Insurance Summit 2025",
    d: "Premio per l’Innovazione e lo Sviluppo nei servizi per la salute, Blue Health Center",
  },
  {
    t: "Health Insurance Summit Awards 2025",
    d: "Premio per la leadership nell’integrazione di servizi e reti nell’ambito salute, Categoria Servizi Salute, Blue Assistance",
  },
  {
    t: "Premio Global Welfare 2025",
    d: "ottobre 2025, Reale Mutua",
  },
  {
    t: "Best Workplaces España",
    d: "1° posto nella categoria delle aziende con oltre 1.000 dipendenti, Reale Seguros",
  },
  {
    t: "Insurance Award, Italy Insurance Forum 2025",
    d: "Miglior Nuovo prodotto, Reale Mutua",
  },
  {
    t: "Premio MF Insurance Awards 2025, “Insurance Elite”",
    d: "“ESG ELITE – Miglior progetto di integrazione di sostenibilità nel business model”, Reale Mutua",
  },
];

export default function Premi({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Premi e riconoscimenti", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[1400] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Premi e riconoscimenti"
    >
      <div
        className="relative w-full md:w-[1280px] bg-white max-h-[90vh] overflow-y-auto overscroll-contain"
        style={{ background: "#E7E3DF", WebkitOverflowScrolling: "touch" }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
          <button
            onClick={() => onShare("Premi")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Condividi"
            aria-label="Condividi"
          >
            <img src={shareIcon} alt="" className="h-4 w-4" />
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <img src={closeIcon} alt="Chiudi" className="h-4 w-4" />
          </button>
        </div>

        {/* Content */}
        <div className="p-8">
          <h2 className="text-[#954e16] text-[30px] md:text-[40px] font-bold">
            Premi e riconoscimenti
          </h2>

          {/* Stage: box a destra (70%), persona + fiocco a sinistra in absolute */}
          <div className="relative mt-10 md:mt-20">
            

            {/* Box 70% allineato a destra, bordo navy, radius 5 */}
            <div className="relative ml-auto w-full md:w-[70%] rounded-[5px] border-[2px] border-[#0E3761] p-6 md:py-12 md:pl-14 md:pr-12">
              {/* Fiocco — angolo in alto a sinistra, sborda fuori dal box (no overflow-hidden) */}
              <img
                src={Fiocco}
                alt=""
                className="hidden md:block absolute -left-[250px] top-[-115px] w-[500px] z-10 pointer-events-none select-none"
              />

              {/* Persona — sborda a sinistra (left negativo) */}
            <img
              src={Persona}
              alt=""
              className="hidden md:block absolute left-[-220px] bottom-[-150px] w-[320px] z-20 pointer-events-none select-none"
            />

              <ul className="relative space-y-5 md:space-y-6 pl-0 md:pl-12">
                {AWARDS.map((a, i) => (
                  <li key={i}>
                    <p className="text-[#0E3761] text-[16px] md:text-[20px] font-bold leading-[1.2] mb-0">
                      {a.t}
                    </p>
                    {a.d && (
                      <p className="text-[#41536F] text-[15px] md:text-[19px] leading-[1.3]">
                        {a.d}
                      </p>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
